import {Component, Input, OnInit, SecurityContext} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {DynamicIdService} from 'shared/_services/dynamic.id.service';
import {ControlTemplate} from '../_interface/control-template.enum';
import {isControlRequired} from '../functions/check-if-control-required.fn';
import {FormFieldWarnings} from '../../../../journal/src/_interface/form-field-warnings.interface';

@Component({
	selector: 'form-textarea',
	templateUrl: './textarea.component.html',
	styleUrls: ['../../../../../src/assets/scss/custom/_forms.scss'],
})
export class TextareaComponent implements OnInit {

	@Input()
	control: UntypedFormControl;

	@Input()
	placeholder: string;

	id: string = this.dynamicIdService.getId('textarea');

	@Input()
	templateFieldId: string;

	@Input()
	label: string;

	@Input()
	template: ControlTemplate = ControlTemplate.horizontal;

	@Input()
	rows = 3;

	@Input()
	cols = 20;

	@Input()
	spellcheck = true;

	@Input() set setWarnings(warnings: FormFieldWarnings) {
		this.warnings = warnings;
	}

	@Input()
	customStyle: { [key: string]: string };

	ControlTemplate = ControlTemplate;
	isControlRequired: boolean;
	warnings: FormFieldWarnings;
	securityContext = SecurityContext;

	constructor(private dynamicIdService: DynamicIdService) {
	}

	ngOnInit(): void {
		if (!this.control) throw new Error('control is required');
		this.isControlRequired = isControlRequired(this.control);
	}

	phraseSelect = ($event: any) => {
		this.control.patchValue((this.control.value || '') + $event.content);
		this.control.markAsDirty();
		this.control.markAsTouched();
	}
}
